import { useContext } from "react";
import { CigLoginContext } from "./CigLoginContextProvider";

const useCigLoginContext = () => useContext(CigLoginContext);

export default useCigLoginContext;
